import { SIM_JOURNEY_TYPES } from '../constants/global'

/**
 * The proposed pre-loaded SIM experiment will allow us to test “pre-loaded” products in the market using existing trading capability functionality and thereby minimise initial investment costs. This will help us validate whether there is a larger opportunity worth committing more resources to.
 * Speed to market with minimal to no development costs is key here. This is why we have decided to hard-code the list of retailers in this module for now. Should the initial test results show promising signs and lead to the go-ahead for pre-loaded SIM's, we will remove this code and implement a more suitable solution for this purpose. Ideally, it would be on Lifecycle's side, as the retailer value should be managed via their CRM.
 */
export const getSimData = () => {
  const simDataFormStorage = localStorage.getItem('simData')
  return simDataFormStorage ? JSON.parse(simDataFormStorage) : null
}

export const getLeadGenerator = () =>
  getSimData()?.leadGenerator ?? 'online-smarty'

export enum PreloadedPlanKeys {
  GB_30 = 'SM_30GB',
  GB_40 = 'SM_40GB',
  UNLIMITED = 'SM_UNLIMITED',
}

const preloadedPlanThirtyGB = {
  key: PreloadedPlanKeys.GB_30,
  values: [
    'Amazon.co.uk-Preload 30GB',
    'Amazon.co.uk–Preload 30GB',
    'Argos-Preload Voice 30GB',
    'Argos - Preloaded Voice 30GB',
    'Efones-Preload Voice 30GB',
  ],
}

const preloadedPlanFortyGB = {
  key: PreloadedPlanKeys.GB_40,
  values: [
    'Argos - Preloaded Voice 40GB',
    'Amazon.co.uk-Preload 40GB',
    'Efones-Preload Voice 40GB',
    'Elite - Preloaded 40GB',
    'UKTD - Preloaded 40GB',
    'TP Link - Preloaded 40GB',
    'SIM Local - Preloaded 40GB',
    'Core - Preloaded 40GB',
  ],
}

const preloadedPlanUnlimited = {
  key: PreloadedPlanKeys.UNLIMITED,
  values: [
    'Amazon.co.uk-Preload UL',
    'Argos-Preload Voice UL',
    'Argos - Preloaded Voice UL',
    'Efones-Preload Voice UL',
    'Elite - Preloaded UL',
    'UKTD - Preloaded UL',
    'TP Link - Preloaded UL',
    'SIM Local - Preloaded UL',
    'Core - Preloaded UL',
  ],
}

export const simMasterData = [
  ...preloadedPlanThirtyGB.values,
  ...preloadedPlanFortyGB.values,
  ...preloadedPlanUnlimited.values,
]

export const getPreloadedSimPlanKey = () => {
  const leadGen = getLeadGenerator()
  const completedArr = [
    preloadedPlanThirtyGB,
    preloadedPlanFortyGB,
    preloadedPlanUnlimited,
  ]
  return completedArr.find((v) => v.values.includes(leadGen))?.key
}

export const getOrderType = () =>
  getSimData()
    ? SIM_JOURNEY_TYPES.SIM_IN_HAND_JOURNEY
    : SIM_JOURNEY_TYPES.ONLINE_SIM_ORDER_JOURNEY

export const isPreloadedSIM = () => {
  const simData = getSimData()

  return (
    simData?.credit === 0 &&
    (simData?.prebakedPlanId ||
      (simData?.leadGenerator && simMasterData.includes(simData.leadGenerator)))
  )
}
